import { Typography, Space } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { LinkedinOutlined, MediumOutlined} from '@ant-design/icons';






export function FooterSmal() {
  return (
    <footer
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#666",
        padding: "30px 0",
        borderTop: "1px solid #e5e5e5",
        background: "linear-gradient(to right, #fafafa, #fff)",
        letterSpacing: "0.3px",
        width: "100%",
        marginTop: "auto",
        marginTop: "50px"
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <div style={{ marginBottom: "6px", fontWeight: 500 }}>
          2023—{new Date().getFullYear()} HackerHub
        </div>
        <div style={{ fontSize: "13px", color: "#888" }}>
          Explore, learn, and improve your security research.
        </div>
      </div>
    </footer>
  );
}


export function Container({ children }){


    return(

    <div
        style={{
            width: "80vw", // 80% ширины окна
            margin: "0 auto",  // центрируем
            height: "100%",
        }}>
        {children}

  </div>


    );
}


export function Footer() {
    return (
      <div style={{ padding: "60px 0", borderTop: "1px solid #d9d9d9" }}>
        <Container>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              backgroundColor: "#ffffff",
            }}
          >
            {/* Контакты */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                // padding: "16px",
              }}
            >
              <div>
                <strong>Our contacts</strong>
              </div>
              <div>
                <p>For counseling</p>{" "}
                <Typography.Text type="secondary">info@hackerhub.pro</Typography.Text>
              </div>
              <div>
                <p>Report a bug</p>{" "}
                <Typography.Text type="secondary">bug@hackerhub.pro</Typography.Text>
              </div>
              {/* <div>
                <p>Download the privacy policy</p>{" "}
                <Typography.Link href="#" target="_blank">
                  Privacy_Policy_HackerHub.pdf
                </Typography.Link>
              </div> */}
            </div>
  
            {/* Партнёрство */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "16px",
              }}
            >
              <div>
                <strong>Become Our Partner</strong>
              </div>
              <Typography.Text type="secondary">partners@hackerhub.pro</Typography.Text>
            </div>
  
            {/* Социальные сети */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
                padding: "16px",
              }}
            >
              <strong>Follow us</strong>
              <div>
                <Space>
                  <Link to={"https://medium.com/@hackerhub"}>
                    <MediumOutlined
                      style={{
                        fontSize: "30px",
                        margin: "10px",
                        color: "rgba(0, 0, 0, 0.45)",
                      }}
                    />
                  </Link>
                  <Link to={"https://www.linkedin.com/in/notrobot/"}>
                    <LinkedinOutlined
                      style={{
                        fontSize: "30px",
                        margin: "10px",
                        color: "rgba(0, 0, 0, 0.45)",
                      }}
                    />
                  </Link>
                </Space>
              </div>
            </div>
          </div>
        </Container>
      </div>
    );
}



export function Menu() {
    return (
      <div style={{}}>
        <Container>
          {/* Верхнее меню */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "60px 0",
              backgroundColor: "#ffffff", // светлый фон
              color: "#000", // тёмный текст
            }}
          >
            <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>HackerHub</div>
            <div style={{ display: "flex", gap: "16px" }}>
              {/* Здесь можно добавить кнопки Sign In / Sign Up */}
              {/* <Button type="default">Sign In</Button>
              <Button type="primary">Sign Up</Button> */}
            </div>
          </div>
        </Container>
      </div>
    );
}



export function MenuSmall() {
  return (
    <div style={{ borderBottom: "1px solid #d9d9d9" }}>
      <Container>
        {/* Верхнее меню */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 0",
            backgroundColor: "#ffffff", // светлый фон
            color: "#000", // тёмный текст
          }}
        >
          <div style={{ fontSize: "1.5rem", fontWeight: "bold" }}>HackerHub</div>
          <div style={{ display: "flex", gap: "16px" }}>
            {/* Здесь можно добавить кнопки Sign In / Sign Up */}
            {/* <Button type="default">Sign In</Button>
            <Button type="primary">Sign Up</Button> */}
          </div>
        </div>
      </Container>
    </div>
  );
}

